export * from './premiumAssets';
export * from './domainPermissions';
export * from './connectedDomainSetupConfig';
export * from './reseller';
export * from './businessTags';
export * from './domainIntentReferral';
export * from './searchOrigin';
export const PROPAGATION_DURATION_HOURS = 48;
export const DOMAIN_STATUSES_BASE_PATH = '/domain-connection';
export const DOMAIN_TLDS_BASE_PATH = '/domain-tlds';
export const DOMAIN_PRICING_BASE_PATH = '/domain-pricing';
export const DOMAIN_SEARCH_BASE_PATH = '/domain-search';
export const CONNECT_DOMAIN_BASE_PATH = '/connect-domain';
export const DAYFULL_DATA_BASE_PATH = '/dayfull';
export const WIX_WAR_BASE_PATH = '/_api/wix';
export const RESELLER_MGMT = '/resellers';
export const DOMAIN_REDEMPTION = '/domain-redemption';
export const ENDPOINTS = {
  pulse: '/pulse',
  experiments: '/experiments',
  capabilities: '/capabilities',
  canChangeDomainOwner: '/can-change-domain-owner',
  resellers: `${RESELLER_MGMT}/get-domain-data`,
  resellersBrandingInfo: `${RESELLER_MGMT}/get-branding-info`,
  accountParams: '/domains-account',
  domainConnection: {
    instances: `${DOMAIN_STATUSES_BASE_PATH}/instances`,
    statuses: `${DOMAIN_STATUSES_BASE_PATH}/statuses`,
    seenStatuses: `${DOMAIN_STATUSES_BASE_PATH}/seen-statuses`,
    hiddenTransfers: `${DOMAIN_STATUSES_BASE_PATH}/hidden-transfers`
  },
  domainTlds: `${DOMAIN_TLDS_BASE_PATH}/list-tlds`,
  domainStartingFromPricing: `${DOMAIN_PRICING_BASE_PATH}/starting-from`,
  domainAvailability: `${DOMAIN_SEARCH_BASE_PATH}/domain-availability`,
  domainSearchDomainData: `${DOMAIN_SEARCH_BASE_PATH}/domain-data`,
  domainSearchAppParams: `${DOMAIN_SEARCH_BASE_PATH}/app-params`,
  domainSearchAddDomainState: `${DOMAIN_SEARCH_BASE_PATH}/add-domain-state`,
  domainSearchSuggestions: `${DOMAIN_SEARCH_BASE_PATH}/suggestions`,
  connectDomain: {
    nameServerWidget: `${CONNECT_DOMAIN_BASE_PATH}/nameServerWidget`,
    protocolErrorScreen: `${CONNECT_DOMAIN_BASE_PATH}/protocolErrorScreen`,
    supportArticle: `${CONNECT_DOMAIN_BASE_PATH}/supportArticle`,
    mailboxInfo: `${CONNECT_DOMAIN_BASE_PATH}/mailboxInfo`,
    currentNameServersAndRegistrar: `${CONNECT_DOMAIN_BASE_PATH}/currentNameServersAndRegistrar`,
    connect: `${CONNECT_DOMAIN_BASE_PATH}`,
    connectionStatus: `${CONNECT_DOMAIN_BASE_PATH}/connectionStatus`
  },
  verifyContactInfo: '/verify-contact-info',
  dayfull: {
    projectsData: `${DAYFULL_DATA_BASE_PATH}/projects-data`,
    restrictedPage: `${DAYFULL_DATA_BASE_PATH}/restricted`
  },
  wixWar: {
    domainPurchaseData: '/domainPurchaseData',
    checkTransferInStatus: '/domainTransferInValidation',
    checkTransferInLockStatus: '/domainTransferInLockValidation'
  },
  apiUrls: {
    listTransferIns: '/_api/domain-delivery/v1/transferRequests'
  },
  domainRedemption: {
    redeem: `${DOMAIN_REDEMPTION}/redeem`
  }
};
export let QUERY_KEYS = /*#__PURE__*/function (QUERY_KEYS) {
  QUERY_KEYS["experiments"] = "experiments";
  QUERY_KEYS["capabilities"] = "capabilities";
  QUERY_KEYS["resellers"] = "resellers";
  QUERY_KEYS["domainAccountParams"] = "domainsAccountParams";
  QUERY_KEYS["domainConnectionStatuses"] = "domainConnectionStatuses";
  QUERY_KEYS["domainConnectionInstances"] = "domainConnectionInstances";
  QUERY_KEYS["domainConnectionHiddenTransfers"] = "domainConnectionHiddenTransfers";
  QUERY_KEYS["domainConnectionSeenStatuses"] = "domainConnectionSeenStatuses";
  QUERY_KEYS["domainTlds"] = "listDomainTlds";
  QUERY_KEYS["domainPricing"] = "domainPricing";
  QUERY_KEYS["domainYearlyPrice"] = "domainYearlyPrice";
  QUERY_KEYS["domainAvailability"] = "domainAvailability";
  QUERY_KEYS["domainSearchDomainData"] = "domainSearchDomainData";
  QUERY_KEYS["domainSearchAppParams"] = "domainSearchAppParams";
  QUERY_KEYS["domainSearchAddDomainState"] = "domainSearchAddDomainState";
  QUERY_KEYS["domainSearchSuggestions"] = "domainSearchSuggestions";
  QUERY_KEYS["connectDomain_nameServerWidget"] = "connectDomain_nameServerWidget";
  QUERY_KEYS["connectDomain_protocolErrorScreen"] = "connectDomain_protocolErrorScreen";
  QUERY_KEYS["connectDomain_supportArticle"] = "connectDomain_supportArticle";
  QUERY_KEYS["connectDomain_mailboxInfo"] = "connectDomain_mailboxInfo";
  QUERY_KEYS["connectDomain_currentNameServersAndRegistrar"] = "connectDomain_currentNameServersAndRegistrar";
  QUERY_KEYS["connectDomain_connect"] = "connectDomain_connect";
  QUERY_KEYS["connectDomain_connectionStatus"] = "connectDomain_connectionStatus";
  QUERY_KEYS["dayfull_projectsData"] = "dayfull_projectsData";
  QUERY_KEYS["dayfull_restrictedPage"] = "dayfull_restrictedPage";
  QUERY_KEYS["domainPurchaseData"] = "domainPurchaseData";
  QUERY_KEYS["checkTransferInStatus"] = "checkTransferInStatus";
  QUERY_KEYS["checkTransferInLockStatus"] = "checkTransferInLockStatus";
  QUERY_KEYS["listTransferIns"] = "listTransferIns";
  return QUERY_KEYS;
}({});
//# sourceMappingURL=index.js.map